import { render, staticRenderFns } from "./MobileTable.vue?vue&type=template&id=a4d0abb0&scoped=true"
import script from "./MobileTable.vue?vue&type=script&lang=js"
export * from "./MobileTable.vue?vue&type=script&lang=js"
import style0 from "./MobileTable.vue?vue&type=style&index=0&id=a4d0abb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d0abb0",
  null
  
)

export default component.exports